import { IconTag } from '@tabler/icons-react';

import { Badge, MantineSize, Skeleton } from '@optiro/ui';

import { useCategories } from '@/hooks/useCategories';
import { Project } from '@/types/types';

const ProjectCategory = ({
  categoryId,
  small = false,
  size = 'lg',
}: {
  categoryId: Project['category_id'];
  small?: boolean;
  size?: MantineSize;
}) => {
  const { data: categories, isLoading } = useCategories();

  if (isLoading || !categories) return <Skeleton height={24} width={80} radius="sm" />;

  const category = categories.find((cat) => cat.id === categoryId);

  if (!category) return null;

  return (
    <Badge variant="light" color="grape" size={size} leftSection={<IconTag size={12} />}>
      {small ? category.name[0] : category.name}
    </Badge>
  );
};

export { ProjectCategory };
